module.exports = __webpack_public_path__ + "static/media/img_02_2x_en.e9e7e362.png";